import { NoSsr } from '@cian/react-utils';
import { Image, IconImage16 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { IFavoriteEntity } from '../../../types/favoriteEntity';
import { EStatus } from '../../../types/filters';
import { getDeletedDateString } from '../../../utils/favoriteEntity';
import { Text } from '../../Text';

interface IImagesProps {
  offer: IFavoriteEntity;
}

export const Images: React.FC<IImagesProps> = ({ offer }) => {
  const { photoPreviewUrl, status, deleteDate, fullUrl } = offer;

  return (
    <div className={styles['container']}>
      <a href={fullUrl} target="_blank" rel="noreferrer">
        {photoPreviewUrl ? (
          <Image
            src={photoPreviewUrl}
            width={288}
            height={162}
            borderRadius="4px"
            alt="Главное фото объявления"
            objectFit="cover"
          />
        ) : (
          <div className={styles['empty_photo']}>
            <IconImage16 color="gray20_100" />
          </div>
        )}
      </a>
      {status && status !== EStatus.Published && (
        <div className={styles['overlay']} data-testid="status_text">
          <div className={styles['text']}>
            <Text bold>
              Объявление
              <br />
              снято с публикации
            </Text>
            {deleteDate && (
              <NoSsr>
                <Text textSize="small" color="black" data-testid="delete_date">
                  Объявление в избранном
                  <br />
                  хранится 90 дней,
                  <br />и будет удалено {getDeletedDateString(deleteDate)}
                </Text>
              </NoSsr>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
